// extracted by mini-css-extract-plugin
module.exports = {"btn_wrap":"bonus-campaigns-page-btn_wrap__hSgDZ","selected":"bonus-campaigns-page-selected__35LG1","sub_category_tooltip":"bonus-campaigns-page-sub_category_tooltip__2I6_k"};